<template>
  <v-dialog
    v-model="planDialog"
    width="500px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <span>Add Coupons</span>
          <i
            class="el-icon-close"
            @click="changeDialog"></i>
        </div>
      </div>
      <div class="dialog-body">
        <div class="coupons-tab">
          <h1>{{customerName}} Coupons</h1>

          <div class="filter-container">
            <div class="filter-box">
              <span class="label">Add Coupon</span>
              <div class="search-box flex">
                <v-select
                  v-model="coupon_code"
                  placeholder="Coupon Title - COUPONCODE"
                  :list="useCouponList"
                  :valueKey="'coupon_code'"
                  labelKey="coupon_code"
                  remote
                  noList
                  :remoteMethod="remoteMethod"
                  @focus="handleFocus"
                >
                  <template #default="scope">
                    <div class="send-info">
                      <span class="info">
                        {{ scope.item.title }} - {{scope.item.coupon_code}}
                      </span>
                    </div>
                  </template>
                </v-select>
                <div class="add-margin">
                  <v-button
                    size="small"
                    type="primary"
                    @click="handlerAddUse"
                  >Add</v-button>
                </div>
              </div>
            </div>
          </div>
          <div class="transparent">
            <div class="coupon-body">
              <div
                v-for="(item,index ) in tableData"
                :key="index"
                class="coupon-content"
                :class="select==index?'is-check-coupon':''"
                @click="handlerSelect(item,index)">
                <div>
                  <span class="coupon-title">{{item.title}}</span>
                  <span class="coupon-code">{{item.coupon_code}}</span>
                  <div class="coupon-mark">
                    <span>{{item.description}}</span>
                  </div>
                </div>
                <div>
                  <span>{{item.unlimited_users==0?'Once ':'Unlimited'}} uses</span>

                  <div
                    v-if="select==index"
                    class="flex select-icon">
                    <span>Selected</span>
                    <i class="el-icon-check"></i>
                  </div>
                  <div
                    v-else
                    class="flex">
                    <span>Expires {{handTime(item.end_time)}}</span>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="flex footer-button">
        <v-button @click="changeDialog">Close</v-button>
        <v-button
          type="success"
          @click="ConfirmCoupon">Confirm</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import dayjs from 'dayjs'
import {addUserCoupon, referCouponQuoteList, referUserQuote} from '@/api/coupon'
import coupon from '@/store/coupon'

export default {
  name: 'ReferCouponSelectDialog',
  components: {
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    customerId: [String, Number],
    orderId: [String, Number],
    classId: [String, Number],
    couponCode: [String, Number],
    isQuote:{
      type:Boolean,
      default:false
    },
    customer: {
      type: [Object,Array],
      default: () => ({})
    },
    couponForm: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      planDialog: false,
      coupon:'',
      tableData: [],
      useCouponList:[],
      coupon_code:'',
      select:-1,
      timer: null
    }
  },
  computed: {
    customerName(){
      let {isrd_nm=''} = this.customer||{}
      return isrd_nm ||''
    },
  },
  watch:{
    tableData:{
      immediate:true,
      handler(val){
        val.forEach((item,index)=>{
          if(this.couponCode==item.coupon_code){
            this.select = index
          }
          if(!this.couponCode)this.select =-1
        })
      }
    },
    couponCode:{
      immediate:true,
      handler(val) {
        if(!val)this.select =-1
        else {
          this.tableData.filter((item,index)=>{
            if(val==item.coupon_code){
              this.select = index
            }
          })
        }
      }
    },
    couponForm:{
      handler(val){
        if(val){
          // this.network().getCouponList()
          this.network().getQuoteCouponList()
        }
      }
    },
    planDialog:{
      immediate:true,
      handler(val){
        if(val){
          // this.network().getCouponList()
          this.network().getQuoteCouponList()
        }
      }
    }
  },
  created(){
    // this.network().getCouponList()
    // this.network().getQuoteCouponList()
  },
  methods: {
    couponTitle(data){
      return data['en-US']
    },
    handTime(time){
      if(time){
        return  dayjs(time).format('DD MMM YYYY')
      }else return '-'
    },
    handlerAddUse(){
      this.network().addUserCoupon()
    },
    handlerSelect(item,index){
      if(this.hasDelete)
        return
      if(this.select==index){
        this.select =-1
        // this.$emit('coupon',{})
        this.coupon ={}
      }else {
        this.select = index
        this.coupon =item
        // this.$emit('coupon',item)
      }

    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getQuoteCouponList()
    },
    remoteMethod(query){
      let params = {
        page: 1,
        size: 100,
        type:1,
        user_id:this.customerId,
        ...this.couponForm,
        class_id:this.classId,
        search_text: query,
        hideLoading: true
      }
      if(this.timer){
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.network().getCouponList(params)
      }, 500)
    },

    handleFocus(){
      this.useCouponList = []
    },
    network() {
      return {
        //列表显示数据 用戶可用的coupons
        getQuoteCouponList:async ()=>{
          if(this.customerId<=0) return
          let {data} = await referUserQuote({
            user_id:this.customerId,
            ...this.couponForm,
            class_id:this.classId,
            order_id:this.orderId
          })
          this.tableData = data
        },
        //选择框可选择coupon
        getCouponList:async (params)=>{
          let {data} = await referCouponQuoteList(params)
          this.useCouponList =data
          let coupon = data.filter(item=>{
            return item.coupon_code == this.couponCode
          })||[]
          let canUse = coupon.length>0
          if(this.couponCode)
            this.$emit('isCanUse',!canUse)
        },
        //用户添加优惠券
        addUserCoupon: async () => {
          const { data } = await addUserCoupon({
            user_id:this.customerId,
            coupon_code: this.coupon_code
          })
          this.network().getQuoteCouponList()
        },

      }
    },
    changeDialog() {
      this.planDialog = !this.planDialog
    },
    ConfirmCoupon(){
      console.log('this.coupon--',this.coupon)
      this.$emit('coupon',this.coupon)
      this.planDialog =false
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .el-dialog{
    border-radius: 4px;
  }
  .dialog-container {
    //padding: 15px;
    border-radius: 5px;
    .plan-header {
      background: #F6F8FA;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      .info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:10px 10px 10px 10px;
        font-size: 14px;
        font-weight: 600;
        color: #24292E;
        i{
          font-weight: 600;
          font-size: 14px;
        }
      }
    }
    .dialog-body{
      padding: 15px;
      max-height: 500px;
      overflow-y: auto;
    }
    .footer-button{
      padding: 15px;
      justify-content: flex-end;
    }
    .coupons-tab {
      position: relative;
      h1 {
        padding-bottom: 15px;
        color: #616266;
        font-size: 16px;
      }
      .filter-container {
        .filter-box {
          margin-bottom: 10px;
          .label {
            display: block;
            padding-bottom: 5px;
            font-size: 14px;
            font-weight: bold;
            .all {
              display: inline-block;
              padding-left: 15px;
              color: #409EFF;
              font-weight: 500;
              cursor: pointer;
            }
          }
          .search-box {
            width: 400px;
          }
          .quote-box {
            width: 300px;
          }
          .add-margin{
            margin-left: 16px;
          }
        }
      }
      .coupon-body{
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .coupon-content{
          background: #fff;
          padding: 16px;
          margin: 0 16px 16px 0;
          border-radius: 4px;
          width: 200px;
          height: 150px;
          border:1px solid #D1D5DA;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .coupon-title{
            color:#24292E;
            font-size:16px!important;
            font-weight: 600;
            text-overflow: ellipsis;
            word-break: break-word;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .coupon-code{
            height: 18px;
            line-height: 18px;
            display: inline-block;
          }
          span{
            color: #6A737D;
            font-size: 12px;
          }
          .coupon-mark{
            margin-top: 5px;
            overflow: hidden;
            span{
              text-overflow: ellipsis;
              word-break: break-word;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
          .flex{
            justify-content: space-between;
            .icon{
              color: #CB2431;
              font-size: 12px;
            }
          }
        }
        .is-check-coupon{
          border: 1px solid #28A745;
          .select-icon{
            color:#28A745;
            font-weight: bold;
          }
        }

      }
    }
    .send-info{
      height: 34px;
      line-height: 34px;
      .info{
        height: 34px;
        line-height: 34px;
      }
    }
  }
</style>
